import { styled } from '@zoopla-eng/zds-components/themes';

export const NewHomesPageSubtitleShort = styled('h3', {
    fontGroup: 'plate',
    color: '$textTitle',
    fontWeight: '$semiBold'
});
